export const Divider = ({ styles }) => (
  <div
    className={`w-full border-dashboardalttext border ${styles && styles}`}
  />
)
